/**
 * Paleta de Cores do CS E2 (mesma base do app/, roxo primário)
 */
export const colors = {
  primary: {
    50: '#f7e9ff',
    100: '#f0d4ff',
    500: '#b14bff',
    600: '#9f3fe6',
    700: '#8c33cc',
    900: '#5c227f',
  },
  gray: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
  },
  success: { light: '#d1fae5', main: '#10b981', dark: '#059669' },
  warning: { light: '#fef3c7', main: '#f59e0b', dark: '#d97706' },
  error: { light: '#fee2e2', main: '#ef4444', dark: '#dc2626' },
  info: { light: '#dbeafe', main: '#3b82f6', dark: '#2563eb' },
  white: '#ffffff',
  gradients: {
    primary: 'linear-gradient(135deg, #c25fff, #8c33cc)',
  },
};
